const SIDES = ["left", "right"];
const SLOTS = ["outer", "inner"];
const sign = (side) => side === "right" ? 1 : -1;
const singleAxle = ({
  axle,
  x,
  radius,
  width,
  halfTrack,
  style = "steel"
}) => SIDES.map((side) => ({
  ref: { axle, side },
  position: [x, radius, sign(side) * halfTrack],
  radius,
  width,
  style
}));
const dualAxle = ({
  axle,
  x,
  radius,
  width,
  halfTrack,
  spacing,
  style = "steel"
}) => SIDES.flatMap(
  (side) => SLOTS.map((slot) => ({
    ref: { axle, side, slot },
    position: [
      x,
      radius,
      sign(side) * (halfTrack + (slot === "outer" ? 1 : -1) * (spacing / 2))
    ],
    radius,
    width,
    style
  }))
);
export {
  dualAxle,
  singleAxle
};
